@if (!openWebsite) {
  <div class="container">
    <div
      class="row backGround items-center"
      [ngClass]="
        currentUser && currentUser.PRODUCTTYPE && currentUser.PRODUCTTYPE == 'Barrister'
          ? 'backGround-purple'
          : 'backGround-green'
      "
    >
      <div>
        <img
          src="assets/images/logos/img_avatar.png"
          alt="Girl in a jacket"
          width="80"
          height="80"
          class="bordar"
        />
      </div>
      <div>
        <p class="user-name">{{ currentUser?.UserName }}</p>
        <p class="info">let's find you an answer</p>
      </div>
      <div class="close-icon">
        <mat-icon (click)="close('themeOptionsPanelHelp')">clear</mat-icon>
      </div>
    </div>
    <div>
      @if (searchResult && searchResult.length > 0) {
        <button style="margin-left: 16px" mat-button class="pading_left" (click)="backToHelp()">
          <mat-icon>keyboard_arrow_left</mat-icon>
          <span style="margin-top: 3px">Back</span>
        </button>
      }
      <div class="row search-div sticky_search_div w-auto">
        <mat-form-field class="search example example-full-width-1" appearance="outline">
          <mat-label>Search</mat-label>
          <input
            matInput
            placeholder="Search"
            [(ngModel)]="searchDataValue"
            (keyup)="onKeyUp($event)"
          />
        </mat-form-field>
      </div>

      <!-- search card list -->
      @if (searchResult && searchResult.length > 0) {
        <div class="row custom_height flex-col">
          @for (searchData of searchResult; track searchData.id) {
            <mat-card appearance="outlined" class="example-card search_card px-4!">
              <mat-card-title>{{ searchData?.title }}</mat-card-title>
              <mat-card-subtitle>{{ searchData?.subcategory }}</mat-card-subtitle>
              <mat-card-content class="px-0!">
                <p>{{ searchData?.description }}</p>
              </mat-card-content>
              <mat-card-actions class="border_bottom px-0!">
                <button
                  mat-stroked-button
                  style="background-color: #f7f7f7"
                  (click)="goTo(searchData.url)"
                >
                  Knowledge base information
                </button>
              </mat-card-actions>
            </mat-card>
          }
        </div>
      }

      @if ((searchResult && searchResult.length == 0) || !searchResult) {
        <div class="row div-card">
          <mat-card appearance="outlined" class="example-card example-full-width">
            <mat-card-title class="heading-font">Top searches for this page</mat-card-title>
            <mat-card-content>
              @if (topMostResult) {
                <mat-list role="list" class="dark-Mode-white">
                  @for (data of topMostResult; track data.id) {
                    <mat-list-item
                      role="listitem"
                      class="list list_top_search px-0"
                      (click)="goTo(data.url)"
                    >
                      {{ data?.title }}
                    </mat-list-item>
                  }
                  <!-- <mat-list-item role="listitem" class="list">Choose your worldflow actions</mat-list-item>
                  <mat-list-item role="listitem" class="list">Connect form to the conversations inbox</mat-list-item>
                  <mat-list-item role="listitem" class="list">Get help with HubSpot</mat-list-item> -->
                </mat-list>
              }
              @if (!topMostResult || topMostResult.length == 0) {
                <p class="result-empty">Result not found!</p>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
      @if ((searchResult && searchResult.length == 0) || !searchResult) {
        <div class="row div-card">
          <mat-card appearance="outlined" class="example-card example-full-width">
            <mat-card-title class="heading-font">Support</mat-card-title>
            <mat-card-content>
              <mat-list role="list">
                <!-- <mat-list-item role="listitem " class="list btn_clicks">
                <mat-icon matSuffix class="icon">people</mat-icon>Ask the community
              </mat-list-item>
              <mat-list-item role="listitem " class="list btn_clicks">
                <mat-icon matSuffix class="icon">mode_inbox</mat-icon>View your support inbox
              </mat-list-item> -->
                <mat-list-item role="listitem" class="list btn_clicks" (click)="openDialog()">
                  <mat-icon matSuffix class="icon">sms</mat-icon>
                  Contact support
                </mat-list-item>
                <mat-list-item
                  role="listitem"
                  class="list btn_clicks"
                  (click)="openRemoteSupport()"
                >
                  <mat-icon matSuffix class="icon">sms</mat-icon>
                  Start Screen Session
                </mat-list-item>
                <mat-list-item
                  role="listitem"
                  class="list btn_clicks"
                  (click)="needRemoteHelpSupport()"
                >
                  <mat-icon matSuffix class="icon">sms</mat-icon>
                  Need help starting a screen session?
                </mat-list-item>
              </mat-list>
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  </div>
}

@if (loader) {
  <div class="example-loading-shade" style="z-index: 99999">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
}

@if (openWebsite) {
  <div class="container" id="iframe-help-desk">
    <div class="row padding_10" id="help-desk-1" style="cursor: pointer">
      <!-- <mat-icon (click)="backToHome()">keyboard_backspace</mat-icon> -->
      <button mat-button class="pading_left" (click)="backToHome()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        <span style="margin-top: 3px">Back</span>
      </button>
      <div class="flex">
        <button mat-icon-button color="primary" (click)="backToHome()">
          <mat-icon>remove</mat-icon>
        </button>
        <button mat-icon-button color="primary" (click)="backToHome()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
    <div class="row new-tab" id="help-desk-2" (click)="newTab()">
      <p style="color: #00a4bd; font-weight: bold">Open in new tab</p>
      <mat-icon style="color: #00a4bd">open in new tab</mat-icon>
    </div>
    <div class="row">
      <iframe
        [src]="openWebsite"
        id="MainPopupIframe"
        width="100%"
        title
        class="ifream-height"
      ></iframe>
    </div>
  </div>
}
